<script setup>
import {useI18n} from "vue-i18n";
import CountryFlag from 'vue-country-flag-next';

const { locale } = useI18n();
const isLocale = (lang) => {
  return locale.value === lang;
}
</script>
<template>
  <header>
    <div class="topbar">
        <div>
            <div class="banner d-none d-sm-flex" >
                <v-row justify="center" align="center">
                    <v-col class="mt-2" justify="center" align="center">
                      <p><a :href="phoneLink" :aria-label="$t('Accessibility.counseling_phone_number')">{{ phone }}</a>&nbsp;<span aria-hidden="true">|&nbsp;</span><a :href="contactLink" :aria-label="$t('Accessibility.counseling_email')">{{ contact }}</a></p>
                    </v-col>
                </v-row>
            </div>
            <div class="header-line"></div>
        </div>
        
        <div>
            
            <div>
                <v-row justify="center" align="center">
                    <v-col cols="3" sm="3" align="left">
                        <a href="https://my.fuerstenberg-institut.de">
                            <v-img class="ma-2 ms-16" src="/assets/myFi.png" min-width="11em" width="11em" :alt="$t('app.logo')"/>
                        </a>
                    </v-col>
                    <v-spacer />
                    <v-col align="right" cols="1" sm="1" class="me-6">
                      <v-btn elevation="0"
                             @click="showLanguages = !showLanguages"
                             v-click-outside="closeLanguage"
                             aria-controls="menu-languages"
                             :aria-haspopup="true"
                             :aria-expanded="showLanguages"
                             :aria-label="$t('Accessibility.choose_language')"
                        >
                        <v-img src="/assets/language.svg" width="1.5em" max-width="1.5em" min-width="1.5em"
                               height="1.5em" max-height="1.5em" min-height="1.5em" class="pointer"
                               aria-hidden="true"
                        />
                      </v-btn>
                    </v-col>
                    <v-col align="right" cols="1" sm="1" class="d-flex d-sm-none me-6">
                        <!--
                        <div class="button d-none d-sm-flex">
                            <a href="https://my.fuerstenberg-institut.de/login" target="_blank">{{ $t('app.login') }}</a>
                        </div>

                        <div>
                            <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                        </div> -->
                    </v-col>

                </v-row>
            </div>
            
        </div>
        
        <div>
            <Transition>
                <div v-if="showLanguages" id="menu-languages" class="d-flex flex-row-reverse pa-2">
                  <ul>
                    <li class="fi-lang-items">
                      <button class="language" :aria-pressed="isLocale('de')" align="center" justify="center" @click="changeLocale('de')">
                        <CountryFlag class="me-2" country="de" size="small" />{{ $t('language.de') }}
                      </button>
                    </li>
                    <li class="fi-lang-items">
                      <button class="language" :aria-pressed="isLocale('en')" align="center" justify="center" @click="changeLocale('en')">
                        <CountryFlag class="me-2" country="gb" size="small" />{{ $t('language.en') }}
                      </button>
                    </li>
                    <li class="fi-lang-items">
                      <button class="language" :aria-pressed="isLocale('pl')" align="center" justify="center" @click="changeLocale('pl')">
                        <CountryFlag class="me-2" country="pl" size="small" />{{ $t('language.pl') }}
                      </button>
                    </li>
                    <li class="fi-lang-items">
                      <button class="language language" :aria-pressed="isLocale('es')" align="center" justify="center" @click="changeLocale('es')">
                        <CountryFlag class="me-2" country="es" size="small" />{{ $t('language.es') }}
                      </button>
                    </li>
                    <li class="fi-lang-items">
                      <button class="language" :aria-pressed="isLocale('fr')" align="center" justify="center" @click="changeLocale('fr')">
                        <CountryFlag class="me-2" country="fr" size="small" />{{ $t('language.fr') }}
                      </button>
                    </li>
                    <li class="fi-lang-items">
                      <button class="language" :aria-pressed="isLocale('it')" align="center" justify="center" @click="changeLocale('it')">
                        <CountryFlag class="me-2" country="it" size="small" />{{ $t('language.it') }}
                      </button>
                    </li>
                  </ul>
                </div>
            </Transition>
        </div>

        <div class="header-line"></div>

    </div>
  </header>
</template>
<script>
export default {
  mounted() {
    this.$i18n.locale = localStorage.getItem('lang') || "de";

  },
  data() {
    return {
        showLanguages: false,
        drawer: false,
        phone: '0800-387 78 36',
        phoneLink: 'tel: +49 800-387 78 36',
        contact: 'coaching@fuerstenberg-institut.de',
        contactLink: 'mailto: coaching@fuerstenberg-institut.de',
        logoDescription: 'Fuerstenberg Institut Logo'
    }
  },
  methods: {
    changeLocale(lang) {
      localStorage.setItem('lang', lang);
      this.$i18n.locale = lang;
      this.showLanguages = false;
    },
    closeLanguage() {
        this.showLanguages = false
    }
  },  
}
</script>

<style scoped>

.topbar {
    background-color: #fff;
    color: black;
}

.banner {
  height: 3.5em;
  background: rgb(222,240,237);
  background: -moz-linear-gradient(135deg, rgba(222,240,237,1) 0%, rgba(190,220,215,1) 100%);
  background: -webkit-linear-gradient(135deg, rgba(222,240,237,1) 0%, rgba(190,220,215,1) 100%);
  background: linear-gradient(135deg, rgba(222,240,237,1) 0%, rgba(190,220,215,1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#def0ed",endColorstr="#bedcd7",GradientType=1);
}

.banner p {
    -webkit-text-size-adjust: 100%;
    --page-title-display: block;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    overflow-wrap: anywhere;
    box-sizing: inherit;
    background-color: transparent;
    transition: all .2s linear;
    outline: none;
    font-family: "Nunito Sans Regular";
    font-weight: 400;
    text-transform: none;
    font-size: 0.8em;
    line-height: 2em;
    letter-spacing: 0;
    color: #272727;
    text-decoration: none;
}
.banner a {
    text-decoration: none;
    color: black;
}

.banner a:hover {
  color: #1C6F62
}

.language {
    cursor: pointer;
    margin-right: 2em;
    font-family: "Nunito Sans Bold";
}

.header-line {
  border-bottom-width: 1px;
  border-bottom-color: #eaeaea;
  border-bottom-style: solid;
}

.fixedBottom {
  position: fixed !important;
  bottom: 0 !important;
  width: 100%;
}

.topbar a {
    text-decoration: none;
    color: black;
}

.topbar a:hover {
  color: #1C6F62
}

.fi-lang-items {
  float: left;
  list-style: none;
}

</style>